import { IconPropsType } from '..';

export const KenoIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    {...props}
  >
    <g clipPath="url(#clip0_15563_7210)">
      <path d="M7 0C10.8662 0 14 3.13385 14 7C14 10.8662 10.8662 14 7 14C3.13385 14 0 10.8662 0 7C0 3.13385 3.13385 0 7 0ZM7 1.00154C3.68846 1.00154 1.00154 3.68846 1.00154 7C1.00154 10.3115 3.68846 12.9985 7 12.9985C10.3115 12.9985 12.9985 10.3115 12.9985 7C12.9985 3.68846 10.3115 1.00154 7 1.00154ZM7 2.00308C9.76231 2.00308 12.0023 4.24308 12.0023 7.00538C12.0023 9.76769 9.76231 12.0077 7 12.0077C4.23769 12.0077 1.99769 9.76231 1.99769 7C1.99769 4.23769 4.23769 1.99769 7 1.99769V2.00308ZM6.79 5.00231H5.49769V9.00308H6.79538V7.40923H6.80615L7.86154 9.00308H9.49308L7.93154 6.83308L9.41769 5.00231H7.85077L6.79538 6.47769H6.78462L6.79 5.00231Z" />
    </g>
    <defs>
      <clipPath id="clip0_15563_7210">
        <rect
          width="14"
          height="14"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
